import { render, staticRenderFns } from "./planned-trips-table.vue?vue&type=template&id=4ca81bb6"
import script from "./planned-trips-table.vue?vue&type=script&lang=js"
export * from "./planned-trips-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports